import { render, staticRenderFns } from "./AppIdentification.vue?vue&type=template&id=4f786eb3&scoped=true&"
import script from "./AppIdentification.vue?vue&type=script&lang=js&"
export * from "./AppIdentification.vue?vue&type=script&lang=js&"
import style0 from "./AppIdentification.vue?vue&type=style&index=0&id=4f786eb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f786eb3",
  null
  
)

export default component.exports